import ApiError from 'utils/api/errors/ApiError';


class ApiBadGatewayError extends ApiError {
  constructor (props) {
    super(props);
    this.name = 'ApiBadGatewayError';
  }
}

export default ApiBadGatewayError;
